import { ColorLens, Delete, Edit } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { ControleGabinete, TipoControle } from '../../modelo';

import '../../css/util.css';
import './css/card.css';
import UsuarioStore from '../../store/UsuarioStore';
import RouterStore from '../../store/RouterStore';
import ControleGabineteStore from '../../store/ControleGabineteStore';
import MensagemStore from '../../store/MensagemStore';
import ProcessoStore from '../../store/ProcessoStore';
import { corTextoContraste } from '../../modelo/StatusRevisao';

interface ICardHeaderProps {
    card: ControleGabinete;
    isConfig: boolean;
    index?: number;
}


class CardHeader extends React.Component<ICardHeaderProps> {
    constructor(props: ICardHeaderProps) {
        super(props);

        makeObservable(this, {

});
    }

    get mostraQuantidade() {
        const isConfig = window.location.href.includes('/configuracaoGabinete');
        // let isCountProcessosOuMinutas = this.props.countProcessos;
        const ehTarefaDistribuir = this.props.card.tipo.id === TipoControle.DISTRIBUIR;
        const isApenasProcessosENaoAssinatura = UsuarioStore.visualizarProcessos && (this.props.card.tipo.id === TipoControle.LISTAGEM || ehTarefaDistribuir);
        return (isConfig ?
            isApenasProcessosENaoAssinatura ?
                '(123)'
                :
                ''
            :
            this.countProcessos
        );
    }

    get countProcessos() {
        const card = this.props.card;
        const filtroOjc = ControleGabineteStore.filtroOJC;
        const cardNumero = card.numero;
        const controle = ControleGabineteStore.listaDeControles.find(
            tarefa => tarefa.numero === cardNumero
        );
        const ehControleEspecial = controle?.isTipo(TipoControle.VOTOVENCIDO) ||
            controle?.isTipo(TipoControle.REDATORDESIGNADO);
        const filtrarPorFluxo = controle?.isTipo(TipoControle.LISTAGEM) ||
            controle?.isTipo(TipoControle.DISTRIBUIR);

        if (!ehControleEspecial && !filtrarPorFluxo) {
            return '';
        }

        const processos = ProcessoStore.processosDoControle(
            cardNumero,
            filtrarPorFluxo,
            filtroOjc
        );

        return processos.length ? `(${processos.length})` : '';
    }

    redirecionar = () => {
        if (this.props.isConfig) return;

        const controleNumero = this.props.card.numero;
        const ojc = ControleGabineteStore.filtroOJC;

        if (!ojc) {
            RouterStore.push(
                `/escaninho/filtrado?controleNumero=${controleNumero}`
            );
            return;
        }

        let ojcParam: string;

        if (Array.isArray(ojc)) {
            const listaNormalizada = ojc.map(item =>
                item.trim().toUpperCase() === 'SEM OJC CADASTRADO'
                    ? 'SEM_OJC'
                    : item.trim()
            );

            ojcParam = encodeURIComponent(listaNormalizada.join(','))
                .replace(/%2C/g, ',');
        } else {
            const normalizado =
                ojc.trim().toUpperCase() === 'SEM OJC CADASTRADO'
                    ? 'SEM_OJC'
                    : ojc.trim();

            ojcParam = encodeURIComponent(normalizado);
        }

        RouterStore.push(
            `/escaninho/filtrado?controleNumero=${controleNumero}&OJC=${ojcParam}`
        );
    };


    verificaExclusao = (index) => {
        const controleParaExcluir = ControleGabineteStore.controlesEmEdicao[index];
        const processosNoControle = ProcessoStore.processosDoControle(controleParaExcluir.numero);
        const qtdProcessos = processosNoControle?.length || 0;
        if (qtdProcessos) {
            MensagemStore.apresentarErro("A movimentação não pode ser excluída pois possui processo(s) ou minuta(s) associado(as) a ela.");
        } else {
            ControleGabineteStore.deletarControle(index);
        }
    }

    alterarCor = (event: React.ChangeEvent<HTMLInputElement>) => {
        const novaCor = event.target.value;
        ControleGabineteStore.atualizarCorControle(this.props.card.numero, novaCor);
    };

    render() {
        const isListagem = this.props.card.tipo.id === TipoControle.LISTAGEM;
        const cor = this.props.card.configControle?.cor || '#1976d2';
        const estiloHeaderListagem = {
            background: cor,
            color: corTextoContraste(cor),
        };
        const classNameHeaderListagem = `w3-container cardHeader header-listagem${this.props.isConfig ? ' has-actions' : ''}`;

        return (
            isListagem ?
                (
                    <Tooltip
                        disableFocusListener={this.props.isConfig}
                        disableHoverListener={this.props.isConfig}
                        disableTouchListener={this.props.isConfig}
                        title="Clique para ir ao Escaninho filtrado por movimentação"
                    >
                        <header
                            className={classNameHeaderListagem}
                            style={{ ...estiloHeaderListagem, cursor: this.props.isConfig ? 'default' : 'pointer' }}
                            onClick={this.props.isConfig ? undefined : this.redirecionar}
                        >
                            <div className="card-header-title">
                                <h6 className="text-align-center">
                                    {this.props.card.descricao} {this.mostraQuantidade}
                                </h6>
                            </div>

                            {this.props.isConfig && (
                                <div
                                    className="card-header-actions"
                                    id="iconesConfiguracao"
                                >
                                    <IconButton
                                        size="small"
                                        style={{ color: 'inherit' }}
                                        sx={{ '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.2)' } }}
                                        component="label"
                                        aria-label="Alterar cor do cabeçalho"
                                    >
                                        <ColorLens />
                                        <input
                                            className="card-header-color-input"
                                            type="color"
                                            value={cor}
                                            onChange={this.alterarCor}
                                            aria-label="Escolher cor do cabeçalho"
                                        />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        style={{ color: 'inherit' }}
                                        sx={{ '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.2)' } }}
                                        onClick={ControleGabineteStore.editarControle.bind(this, this.props.index)}
                                    >
                                        <Edit />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        style={{ color: 'inherit' }}
                                        sx={{'&:hover': {backgroundColor: 'rgba(255, 255, 255, 0.2)'}}}
                                        onClick={() => this.verificaExclusao(this.props.index)}
                                    >
                                        <Delete />
                                    </IconButton>
                                </div>
                            )}
                        </header>
                    </Tooltip>
                )
                :
                (
                    <header className="w3-container cardHeader header-acao">
                        <h6 className="text-align-center">
                            {this.props.card.descricao} {this.mostraQuantidade}
                        </h6>
                    </header>
                )
        );
    }
}

export default observer(CardHeader);
